var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "patchmanager" } },
    [
      _c("vue-loading", {
        attrs: {
          active: _vm.loading,
          "is-full-page": true,
          loader: "dots",
          color: "#70A1F0"
        },
        on: {
          "update:active": function($event) {
            _vm.loading = $event
          }
        }
      }),
      _vm._v(" "),
      _vm.active != null
        ? _c(
            "nav",
            { staticClass: "navbar fixed-top-sub navbar-light bg-light" },
            [
              _c("div", { staticClass: "navbar-brand" }, [
                _vm._v("Patch Manager")
              ]),
              _vm._v(" "),
              _c("ul", { staticClass: "nav nav-pages mr-auto" }, [
                _c("li", { staticClass: "nav-item" }, [
                  _c(
                    "a",
                    {
                      staticClass: "nav-link",
                      class: { active: _vm.view === "overview" },
                      attrs: { type: "button" },
                      on: {
                        click: function($event) {
                          _vm.view = "overview"
                        }
                      }
                    },
                    [_vm._v("Overview")]
                  )
                ]),
                _vm._v(" "),
                _c("li", { staticClass: "nav-item" }, [
                  _c(
                    "a",
                    {
                      staticClass: "nav-link",
                      class: { active: _vm.view === "critical" },
                      attrs: { type: "button" },
                      on: {
                        click: function($event) {
                          _vm.view = "critical"
                        }
                      }
                    },
                    [_vm._v("Critical / Important Patches")]
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "nav-item btn-group dropdown" }, [
                _c(
                  "button",
                  {
                    staticClass:
                      "btn-block btn dropdown-toggle btn-secondary text-right",
                    staticStyle: { "margin-right": "10px" },
                    attrs: {
                      type: "button",
                      "data-toggle": "dropdown",
                      "aria-haspopup": "true",
                      "aria-expanded": "false"
                    }
                  },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.active.account_name || _vm.active.account) +
                        "\n      "
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "dropdown-menu dropdown-menu-right scrollable-menu"
                  },
                  [
                    _c("h6", { staticClass: "dropdown-header" }, [
                      _vm._v("Accounts")
                    ]),
                    _vm._v(" "),
                    _vm._l(_vm.patchmanager, function(report) {
                      return _c("div", { key: report.account }, [
                        _c(
                          "a",
                          {
                            staticClass: "dropdown-item",
                            on: {
                              click: function($event) {
                                return _vm.setActive(report)
                              }
                            }
                          },
                          [
                            _vm._v(
                              _vm._s(report.account_name || report.account)
                            )
                          ]
                        )
                      ])
                    })
                  ],
                  2
                )
              ]),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn btn-primary text-right",
                  attrs: { type: "button" },
                  on: { click: _vm.downloadCSV }
                },
                [_vm._v("Download Report")]
              )
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.view === "overview" && _vm.active != null
        ? _c("div", [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-3" }, [
                _c(
                  "div",
                  { staticClass: "row" },
                  [
                    _c("transition", { attrs: { name: "fade", appear: "" } }, [
                      _c("div", { staticClass: "card col" }, [
                        _c("div", { staticClass: "card-heading" }, [
                          _c("h4", [_vm._v("Account")])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "card-body" }, [
                          _c("dl", [
                            _c("dt", [_vm._v("Contract")]),
                            _c("dd", [_vm._v(_vm._s(_vm.active.contract))]),
                            _vm._v(" "),
                            _c("dt", [_vm._v("Account Name")]),
                            _c("dd", [_vm._v(_vm._s(_vm.active.account_name))]),
                            _vm._v(" "),
                            _c("dt", [_vm._v("Account Id")]),
                            _c("dd", [_vm._v(_vm._s(_vm.active.account))]),
                            _vm._v(" "),
                            _c("dt", [_vm._v("Total Instances")]),
                            _c("dd", [
                              _vm._v(_vm._s(_vm.activeCompliance.length))
                            ]),
                            _vm._v(" "),
                            _c("dt", [_vm._v("Last Updated")]),
                            _c("dd", [
                              _vm._v(
                                _vm._s(
                                  _vm.formatTimestamp(_vm.active.timestamp)
                                )
                              )
                            ])
                          ])
                        ])
                      ])
                    ])
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "row" },
                  [
                    _c("transition", { attrs: { name: "fade", appear: "" } }, [
                      _c("div", { staticClass: "card col" }, [
                        _c("div", { staticClass: "card-heading" }, [
                          _c("h4", [_vm._v("Compliance Summary")])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "card-body" }, [
                          _c("div", { staticClass: "compliance-stat" }, [
                            _c(
                              "span",
                              { staticClass: "stat-label compliant" },
                              [_vm._v("Compliant")]
                            ),
                            _vm._v(" "),
                            _c("span", { staticClass: "stat-count" }, [
                              _vm._v(_vm._s(_vm.complianceCounts.compliant))
                            ])
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "compliance-stat" }, [
                            _c(
                              "span",
                              { staticClass: "stat-label non-compliant" },
                              [_vm._v("Non-Compliant")]
                            ),
                            _vm._v(" "),
                            _c("span", { staticClass: "stat-count" }, [
                              _vm._v(_vm._s(_vm.complianceCounts.nonCompliant))
                            ])
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "compliance-stat" }, [
                            _c(
                              "span",
                              { staticClass: "stat-label compliant-pct" },
                              [_vm._v("Compliance Rate")]
                            ),
                            _vm._v(" "),
                            _c("span", { staticClass: "stat-count" }, [
                              _vm._v(_vm._s(_vm.complianceRate) + "%")
                            ])
                          ])
                        ])
                      ])
                    ])
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "row" },
                  [
                    _c("transition", { attrs: { name: "fade", appear: "" } }, [
                      _c("div", { staticClass: "card col" }, [
                        _c("div", { staticClass: "card-heading" }, [
                          _c("h4", [_vm._v("Platform Breakdown")])
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "card-body" },
                          _vm._l(_vm.platformCounts, function(count, platform) {
                            return _c(
                              "div",
                              { key: platform, staticClass: "severity-bar" },
                              [
                                _c("span", { staticClass: "platform-label" }, [
                                  _vm._v(_vm._s(platform || "Unknown"))
                                ]),
                                _vm._v(" "),
                                _c("span", { staticClass: "severity-count" }, [
                                  _vm._v(_vm._s(count))
                                ])
                              ]
                            )
                          }),
                          0
                        )
                      ])
                    ])
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-9" },
                [
                  _c(
                    "transition",
                    { attrs: { name: "fade", appear: "" } },
                    [
                      _c("vue-good-table", {
                        attrs: {
                          columns: _vm.complianceColumns,
                          rows: _vm.activeCompliance,
                          "search-options": {
                            enabled: true,
                            skipDiacritics: true,
                            placeholder: "filter instances"
                          },
                          "pagination-options": {
                            enabled: true,
                            perPage: 25
                          },
                          "sort-options": {
                            enabled: true,
                            initialSortBy: {
                              field: "missing_count",
                              type: "desc"
                            }
                          },
                          "row-style-class": _vm.complianceRowStyleFn,
                          styleClass: "vgt-table condensed"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.view === "critical" && _vm.active != null
        ? _c("div", [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-3" }, [
                _c(
                  "div",
                  { staticClass: "row" },
                  [
                    _c("transition", { attrs: { name: "fade", appear: "" } }, [
                      _c("div", { staticClass: "card col" }, [
                        _c("div", { staticClass: "card-heading" }, [
                          _c("h4", [_vm._v("Account")])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "card-body" }, [
                          _c("dl", [
                            _c("dt", [_vm._v("Contract")]),
                            _c("dd", [_vm._v(_vm._s(_vm.active.contract))]),
                            _vm._v(" "),
                            _c("dt", [_vm._v("Account Name")]),
                            _c("dd", [_vm._v(_vm._s(_vm.active.account_name))]),
                            _vm._v(" "),
                            _c("dt", [_vm._v("Account Id")]),
                            _c("dd", [_vm._v(_vm._s(_vm.active.account))]),
                            _vm._v(" "),
                            _c("dt", [_vm._v("Critical / Important")]),
                            _c("dd", [
                              _vm._v(_vm._s(_vm.activeCriticalPatches.length))
                            ])
                          ])
                        ])
                      ])
                    ])
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "row" },
                  [
                    _c("transition", { attrs: { name: "fade", appear: "" } }, [
                      _c("div", { staticClass: "card col" }, [
                        _c("div", { staticClass: "card-heading" }, [
                          _c("h4", [_vm._v("Patch State Breakdown")])
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "card-body" },
                          _vm._l(_vm.patchStateOrder, function(state) {
                            return _c(
                              "div",
                              { key: state, staticClass: "severity-bar" },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass: "severity-label",
                                    class: "state-" + state.toLowerCase()
                                  },
                                  [_vm._v(_vm._s(state))]
                                ),
                                _vm._v(" "),
                                _c("span", { staticClass: "severity-count" }, [
                                  _vm._v(
                                    _vm._s(_vm.patchStateCounts[state] || 0)
                                  )
                                ])
                              ]
                            )
                          }),
                          0
                        )
                      ])
                    ])
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.activePatch != null
                  ? _c(
                      "div",
                      { staticClass: "row" },
                      [
                        _c(
                          "transition",
                          { attrs: { name: "fade", appear: "" } },
                          [
                            _c("div", { staticClass: "card col" }, [
                              _c("div", { staticClass: "card-heading" }, [
                                _c("h4", [_vm._v("Patch Detail")])
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "card-body finding-detail" },
                                [
                                  _c("dl", [
                                    _c("dt", [_vm._v("KB / Patch ID")]),
                                    _vm._v(" "),
                                    _c("dd", [
                                      _vm._v(_vm._s(_vm.activePatch.kb_id))
                                    ]),
                                    _vm._v(" "),
                                    _c("dt", [_vm._v("Title")]),
                                    _vm._v(" "),
                                    _c("dd", [
                                      _vm._v(_vm._s(_vm.activePatch.title))
                                    ]),
                                    _vm._v(" "),
                                    _c("dt", [_vm._v("Classification")]),
                                    _vm._v(" "),
                                    _c("dd", [
                                      _vm._v(
                                        _vm._s(_vm.activePatch.classification)
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("dt", [_vm._v("Severity")]),
                                    _vm._v(" "),
                                    _c("dd", [
                                      _c(
                                        "span",
                                        {
                                          class:
                                            "severity-badge severity-" +
                                            _vm.activePatch.severity.toLowerCase()
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.activePatch.severity)
                                          )
                                        ]
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("dt", [_vm._v("State")]),
                                    _vm._v(" "),
                                    _c("dd", [
                                      _c(
                                        "span",
                                        {
                                          class:
                                            "state-badge state-" +
                                            _vm.activePatch.state.toLowerCase()
                                        },
                                        [_vm._v(_vm._s(_vm.activePatch.state))]
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("dt", [_vm._v("Instance")]),
                                    _vm._v(" "),
                                    _c("dd", [
                                      _vm._v(
                                        _vm._s(_vm.activePatch.instance_id)
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("dt", [_vm._v("Instance Name")]),
                                    _vm._v(" "),
                                    _c("dd", [
                                      _vm._v(
                                        _vm._s(_vm.activePatch.instance_name)
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("dt", [_vm._v("Platform")]),
                                    _vm._v(" "),
                                    _c("dd", [
                                      _vm._v(
                                        _vm._s(_vm.activePatch.platform_name)
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("dt", [_vm._v("Region")]),
                                    _vm._v(" "),
                                    _c("dd", [
                                      _vm._v(_vm._s(_vm.activePatch.region))
                                    ]),
                                    _vm._v(" "),
                                    _vm.activePatch.installed_time
                                      ? _c("dt", [_vm._v("Installed")])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.activePatch.installed_time
                                      ? _c("dd", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.activePatch.installed_time
                                            )
                                          )
                                        ])
                                      : _vm._e()
                                  ]),
                                  _vm._v(" "),
                                  _vm.activePatch.cve_ids &&
                                  _vm.activePatch.cve_ids.length
                                    ? _c(
                                        "div",
                                        { staticClass: "detail-section" },
                                        [
                                          _c("h5", [_vm._v("CVE IDs")]),
                                          _vm._v(" "),
                                          _vm._l(
                                            _vm.activePatch.cve_ids,
                                            function(cve) {
                                              return _c(
                                                "div",
                                                {
                                                  key: cve,
                                                  staticClass: "cve-item"
                                                },
                                                [
                                                  _c(
                                                    "a",
                                                    {
                                                      attrs: {
                                                        href:
                                                          "https://nvd.nist.gov/vuln/detail/" +
                                                          cve,
                                                        target: "_blank"
                                                      }
                                                    },
                                                    [_vm._v(_vm._s(cve))]
                                                  )
                                                ]
                                              )
                                            }
                                          )
                                        ],
                                        2
                                      )
                                    : _vm._e()
                                ]
                              )
                            ])
                          ]
                        )
                      ],
                      1
                    )
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-9" },
                [
                  _c(
                    "transition",
                    { attrs: { name: "fade", appear: "" } },
                    [
                      _c(
                        "vue-good-table",
                        {
                          attrs: {
                            columns: _vm.criticalPatchColumns,
                            rows: _vm.activeCriticalPatches,
                            "search-options": {
                              enabled: true,
                              skipDiacritics: true,
                              placeholder: "filter patches"
                            },
                            "pagination-options": {
                              enabled: true,
                              perPage: 25
                            },
                            "sort-options": {
                              enabled: true,
                              initialSortBy: { field: "state", type: "asc" }
                            },
                            "row-style-class": _vm.patchRowStyleFn,
                            styleClass: "vgt-table condensed"
                          },
                          on: { "on-row-click": _vm.onPatchRowClick }
                        },
                        [
                          _c(
                            "div",
                            {
                              attrs: { slot: "table-actions" },
                              slot: "table-actions"
                            },
                            [
                              _c(
                                "button",
                                {
                                  staticClass:
                                    "btn btn-danger btn-margin btn-sm",
                                  attrs: { type: "button" },
                                  on: {
                                    click: function($event) {
                                      return _vm.filterByState("Missing")
                                    }
                                  }
                                },
                                [_vm._v("Missing")]
                              ),
                              _vm._v(" "),
                              _c(
                                "button",
                                {
                                  staticClass:
                                    "btn btn-warning btn-margin btn-sm",
                                  attrs: { type: "button" },
                                  on: {
                                    click: function($event) {
                                      return _vm.filterByState("Failed")
                                    }
                                  }
                                },
                                [_vm._v("Failed")]
                              ),
                              _vm._v(" "),
                              _c(
                                "button",
                                {
                                  staticClass:
                                    "btn btn-success btn-margin btn-sm",
                                  attrs: { type: "button" },
                                  on: {
                                    click: function($event) {
                                      return _vm.filterByState("Installed")
                                    }
                                  }
                                },
                                [_vm._v("Installed")]
                              ),
                              _vm._v(" "),
                              _c(
                                "button",
                                {
                                  staticClass:
                                    "btn btn-secondary btn-margin btn-sm",
                                  attrs: { type: "button" },
                                  on: { click: _vm.showAllPatches }
                                },
                                [_vm._v("Show All")]
                              )
                            ]
                          )
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      !_vm.loading && _vm.patchmanager.length === 0
        ? _c("div", { staticClass: "row empty-state" }, [_vm._m(0)])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col text-center" }, [
      _c("h4", [_vm._v("No Patch Manager data available")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "Patch compliance data will appear here once the feature is deployed and reports are collected."
        )
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-be3d2602", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-be3d2602","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/PatchManager.vue
// module id = null
// module chunks = 